import {
	IonButton,
	IonCol,
	IonGrid,
	IonIcon,
	IonImg,
	IonItem,
	IonList,
	IonRow,
} from "@ionic/react";
import { trash } from "ionicons/icons";
import React, { useContext, useEffect, useState } from "react";
import { ImageUploadContext } from "react-capacitor-firebase-image-upload";
import { getImageURL } from "../services/util";

interface props {
	onChange: any;
	name: any;
	id: any;
	value: any;
	pathPrefix: any;
}

const FileUpload: React.FC<props> = ({
	onChange,
	name,
	id,
	value,
	pathPrefix,
}) => {
	const { open } = useContext(ImageUploadContext);
	const [imageURL, setImageURL] = useState<any>("");

	const successCallback = (file: any) => {
		if (file) {
			onChange({ file: file, id, name });
		}
	};

	const _removePhoto = () => {
		onChange({ image: { downloadUrl: "" }, id, name });
		setImageURL("");
	};

	useEffect(() => {
		if (value) {
			setImageURL("");
			getImageURL(value, "600").then((url: any) => {
				if (url) {
					setImageURL(url);
				} else {
					getImageURL(value, "full").then((url: any) => {
						setImageURL(url);
					});
				}
			});
		} else setImageURL("");
		//eslint-disable-next-line
	}, [value]);

	return (
		<IonGrid>
			<IonRow>
				{imageURL && (
					<IonCol>
						<IonImg src={imageURL} alt="uploaded image" />
					</IonCol>
				)}
			</IonRow>
			<IonRow>
				{!imageURL && (
					<IonCol>
						<IonButton
							onClick={() =>
								open(successCallback, console.error, { pathPrefix })
							}
						>
							Upload Image
						</IonButton>
					</IonCol>
				)}
				{imageURL && (
					<IonCol>
						<IonButton
							onClick={() =>
								open(successCallback, console.error, { pathPrefix })
							}
						>
							Change Image
						</IonButton>
						<IonButton fill="outline" onClick={_removePhoto}>
							<IonIcon icon={trash} />
						</IonButton>
					</IonCol>
				)}
			</IonRow>
		</IonGrid>
	);
};

export default FileUpload;
